import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useNavigate, useParams } from "react-router-dom";
import SimilarPosts from "../../SearchAll/AllPosts/SimilarPosts";
import { useDispatch, useSelector } from "react-redux";
import {
  addtowishinpostbyid,
  getPBPUmbrellaById,
  getPostsById,
} from "../../../../../redux/posts/action";
import Access from "../../../../CustomComponents/Access/Access";
import getTimeDifference from "../../../../Common/TimeDifference";
import {
  formatNumberWithCommas,
  getMemberSince,
  getPosttype,
} from "../../../../Common/AllDateTimeReleventFormate";
import DownloadwithDisplayProper from "../../../../Common/FilesRelevent/DownloadwithDisplayProper";
import { Tooltip } from "react-tooltip";
import CustomeMilestone from "../../../../Common/CustomeLabel/CustomeMilestone";
import CustomeDurationLabel from "../../../../Common/CustomeLabel/CustomeDurationLabel";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import CustomeCategoryandSubcategory from "../../../../Common/CustomeLabel/CustomeCategoryandSubcategory";
import ProfilePic from "../../../../../assests/imgs/Profileplaceholder.svg";
import { getSortNamePostType, IS_LOGGED_IN_USER, decodeHtml, getUmbrella } from "../../../../../assests/extention/commonfunction";
import AbouttheClient from "../../../../Common/AbouttheClient";
import HomeCommonNavigation from "../../../../Common/HomeCommonNavigation";
import ProfileImageWithFallback from "../../../../../common/ProfileImageWithFallback";
import AllStatusLabels from "../../SearchAll/AllPosts/AllStatusLabels";
import img from '../../../../../assests/imgs/contest.png'
import ParticipateImage from "../../SearchContestParticipate/ContestDetails/ParticipateImage";

export default function ProjectDetails() {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const path = "Assets/scss/FindWork.module.scss";
  const [modal, setModal] = useState(false);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const { id } = useParams();
  const posts = useSelector(({ posts: { postbyid } }) => postbyid);
  const pbpData = useSelector(({ posts: { pbpbyid } }) => pbpbyid);
  const dispatch = useDispatch();
  console.log(pbpData, "pbpDatapbpDatapbpDatapbpData")
  
 // 1. First call: Fetch the post whenever the URL 'id' changes
  useEffect(() => {
    if (id) {
      dispatch(getPostsById(id));
    }
  }, [id, dispatch]);

  // 2. Second call: Watch for 'posts.parent_id' to populate, THEN fetch the umbrella data
  useEffect(() => {
    if (posts?.parent_id) {
      dispatch(getPBPUmbrellaById(posts.parent_id));
    }
  }, [posts?.parent_id, dispatch]);

  const checkaccessss = () => {
    setModal(true);
  };
  
  const addtowishlist11 = (id) => {
    dispatch(addtowishinpostbyid(id));
  };

  const navigatetopost = (item) => {
    navigate(`/${lan}/projectdetails/${item.id}`);
    window.scrollTo(0, 0);
  };

  return (
    <div className=" project-section project-details col-lg-10 mx-auto">
      {modal ? (
        <Access
          modal={modal}
          setModal={setModal}
          pathurl={`/${lan}/submitprojectproposal/${posts.id}`}
          state={"state"}
          checkpermission={"bid_project"}
          masterID={posts && posts.id}
        />
      ) : (
        ""
      )}
      <p className="breadcrumbs">
        <HomeCommonNavigation type={posts?.type} />Project details
      </p>
      <div className="row">
        <div className="col-lg-9 col-md-8">
          <div className="post-details p-0 project-border-sec" style={{ border: "0" }}>
            <div className="filter-detail justify-contnt-between">
              <div className="w-100   project-width">
                <h5>
                  {decodeHtml(posts.title)} <span className="project">{getSortNamePostType(posts.type)}  </span> {getUmbrella(posts.is_ambrella)}
                </h5>
                <div className="dollar-sec">
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/dollar.svg`}
                      alt=""
                    />{" "}
                    Budget: $ {formatNumberWithCommas(posts.price)}
                  </p>
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
                      alt=""
                    />
                    Deadline:&nbsp;
                    <CustomeDurationLabel
                      duration={posts?.duration}
                      duration_type={posts?.duration_type}
                    />
                  </p>
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/message.svg`}
                      alt=""
                    />
                    Posted: {getTimeDifference(posts?.created_on)}
                  </p>
                </div>
                <CustomeCategoryandSubcategory posts={posts} />

                <div className="lang-sec">
                  <h6>Preferred language</h6>
                  <p>{decodeHtml(posts.language_title)}</p>
                </div>
                <div className="lang-sec">
                  <h6>Description</h6>
                  <CustomReactQuillDescription value={posts.description} />
                </div>
                <div className="lang-sec">
                  <h6>Competencies and expertise</h6>
                  <div className="skills-expert">
                    {posts.skills &&
                      Array.isArray(posts.skills) &&
                      posts.skills.map((item, index) => {
                        return <p key={index}> {decodeHtml(item.title)} </p>;
                      })}
                  </div>
                </div>
                {Array.isArray(posts?.files) &&
                  posts?.files &&
                  posts?.files?.length > 0 && (
                    <div className="lang-sec">
                      <h6>Attachments</h6>
                      <div className="images ">
                        {posts?.files.map((item, index) => {
                          return <DownloadwithDisplayProper item={item} key={index} />;
                        })}
                      </div>
                    </div>
                  )}
                <div className="lang-sec">
                  <h6>Deliverables</h6>
                  <CustomReactQuillDescription value={posts?.deliverables} />
                </div>
                <CustomeMilestone milestones={posts?.milestones} />
                <div className="lang-sec">
                  <h6 className="activity-post"> Activity on this post</h6>
                  <div className="post-p">
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/post-proposal.svg`}
                        alt=""
                      />
                      Proposal: {posts?.proposal_count}
                    </p>
                    {posts?.is_mine == 1 ? (
                      ""
                    ) : (
                      <p>
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/eye.svg`}
                          alt=""
                        />
                        Last viewed by client:
                        {getTimeDifference(posts?.last_viewed_client)}
                      </p>
                    )}
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/interview.svg`}
                        alt=""
                      />
                      Seen: {posts?.view_count}
                    </p>
                  </div>
                </div>

                 {pbpData && pbpData.length > 0 && (
            <div className="mt-5">
              <hr className="mb-4" />
              <h4 style={{ color: '#001e60', fontWeight: 'bold', marginBottom: '24px' }}>
                Other PBP inside this umbrella
              </h4>
              
              {pbpData.map((item, index) => (
                <div className="filter-detail" style={{ borderRadius: "12px", border: "1px solid #E2E8F0", padding: "24px", marginBottom: "16px", position: "relative" }} key={index}>
                  <div
                    className="w-100 project-width"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigatetopost(item);
                    }}
                  >
                    <h5>
                      {decodeHtml(item.title)} {getSortNamePostType(item.type)}  {getUmbrella(posts.is_ambrella)}
                    </h5>
                    <div className="dollar-sec">
                      <p>
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/dollar.svg`}
                          alt=""
                        />
                        {item?.type == 2 ? "Prize" : "Budget"}: $
                        {formatNumberWithCommas(item.price)}
                      </p>
                      {item?.type == 3 ? (
                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/job-type.svg`}
                            alt=""
                          />
                          Job type: {" "}
                          {item?.work_location == 1
                            ? "Virtual"
                            : item?.work_location == 2
                              ? "Physical"
                              : ""}
                        </p>
                      ) : (
                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
                            alt=""
                          />
                          Deadline:&nbsp;
                          {item?.type == 2 ? (
                            <> {getMemberSince(item?.last_date)} </>
                          ) : (
                            <>
                              {item?.duration}&nbsp;
                              {item?.duration_type == 2
                                ? "Days"
                                : item?.duration_type == 3
                                  ? "Weeks"
                                  : item?.duration_type == 4
                                    ? "Months"
                                    : ""}
                            </>
                          )}
                        </p>
                      )}
                      <p>
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/message.svg`}
                          alt=""
                        />
                        Posted:{getTimeDifference(item.created_on)}
                      </p>
                    </div>
                    <CustomReactQuillDescription value={item.description}
                      displyreadorless={false} />
                    <div className="photoshop d-flex gap-2 flex-wrap mb-3 mt-3">
                      {Array.isArray(item?.skills) &&
                        item?.skills.map((item1, index1) => (
                          <span style={{ backgroundColor: "#f1f5f9", padding: "6px 12px", borderRadius: "4px", fontSize: "14px", color: "#334155", fontWeight: "500" }} key={index1}>{decodeHtml(item1.title)}</span>
                        ))}
                    </div>
                    <div className="proposal d-flex align-items-center gap-4 text-muted">
                      <p className="mb-0 d-flex align-items-center gap-2">
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/proposal.svg`}
                          alt=""
                        />
                        {item?.type == 2 ? "Entries" : "Proposal"}:
                        {item.proposal_count}
                      </p>
                      {item?.type == 3 ? (
                        <p className="mb-0 d-flex align-items-center gap-2">
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                            alt=""
                          />
                          Location: {decodeHtml(item.city_name)}
                        </p>
                      ) : (
                        <p className="mb-0 d-flex align-items-center gap-2">
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                            alt=""
                          />
                          Location: {item?.city_name ? decodeHtml(item.city_name) : 'Riyadh'}
                        </p>
                      )}
                      <p className="mb-0 d-flex align-items-center gap-2">
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/payment.svg`}
                          alt=""
                        />
                        Verified Payment
                      </p>
                    </div>
                  </div>
                  <button
                    className="btn heart-btn position-absolute"
                    style={{ top: "24px", right: "24px" }}
                    onClick={() => {
                      item.wishlist == 1
                        ? addtowishlist11(item?.id, 1)
                        : addtowishlist11(item?.id, 1);
                    }}
                  >
                    {item.wishlist == 1 ? (
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/heart-active.svg`}
                        alt=""
                      />
                    ) : (
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/heart.svg`}
                        alt=""
                      />
                    )}
                  </button>
                </div>
              ))}
            </div>
          )}

          
              </div>
              <button
                className="btn heart-btn"
                onClick={() => {
                  if (IS_LOGGED_IN_USER) {
                    posts.wishlist == 1
                      ? addtowishlist11(posts?.id, 1)
                      : addtowishlist11(posts?.id, 1);
                  }
                  else {
                    setModal(true);
                  }
                }}
              >
                {posts.wishlist == 1 ? (
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/heart-active.svg`}
                    alt=""
                  />
                ) : (
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/heart.svg`}
                    alt=""
                  />
                )}
              </button>
            </div>
          </div>

         

        </div>
        <div className="col-lg-3 col-md-4">
          <div className="like-project">
            <div className="first-sec">
              <ParticipateImage />
              <h5>{posts.is_mine == 1 ? "Your post" : "Like this project?"}</h5>
              <p>
                {posts.is_mine == 1
                  ? "Do you want to modify this post"
                  : "Apply to send your proposal"}
              </p>
              {posts.is_mine == 1 ? (
                ""
              ) : (
                <>
                  {!posts?.proposed_status ? (
                    <button className="btn" onClick={() => checkaccessss()}>
                      Apply Now
                    </button>
                  ) : (
                    <>
                      <AllStatusLabels status_id={posts?.proposed_status} />
                    </>
                  )}
                </>
              )}
              {posts.is_mine == 1 && (
                <button
                  className="btn"
                  onClick={() =>
                    navigate(`/${lan}/account/updateproject/${posts.id}`)
                  }
                  disabled={posts?.proposal_count}
                >
                  Update
                </button>
              )}
            </div>
            {posts.is_mine == 1 ? (
              ""
            ) : (
              <AbouttheClient posts={posts} />
            )}
          </div>
        </div>
        <div className="col-lg-9 col-md-8">
          <SimilarPosts posts={posts} />
        </div>
      </div>
    </div >
  );
}